<template>
  <div class="video-js-wrapper">
    <video ref="videoPlayer" class="video-js" :poster="poster"></video>
  </div>
</template>

<script>
import VideoJS from "video.js";
import "video.js/dist/video-js.css";
import { addWatchTimes, getWatchTimes } from "@/api/video";
import { mapGetters } from "vuex";

export default {
  name: "VideoPlayer",
  props: {
    options: {
      type: Object,
      required: true,
      default: () => {}
    },
    videoId: {
      type: Number,
      required: true,
      default: 0
    },
    poster: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      player: null,
      startTime: null,
      isOver: false
    };
  },
  watch: {
    "options.sources": function() {
      this.reInit();
    }
  },
  beforeDestroy() {
    this.destroy();
  },
  mounted() {
    if (this.options.sources) {
      this.init();
    }
  },
  methods: {
    ...mapGetters("user", ["logged"]),
    async init() {
      this.startTime = new Date();
      const { isover, totalCount } = await getWatchTimes();
      this.isOver = isover;
      if (isover) {
        this.$emit("exceed-limit-times", totalCount);
        return;
      }
      let _this = this;
      this.player = VideoJS(
        this.$refs["videoPlayer"],
        { ...this.options, language: "zh-Hans" },
        async function() {
          _this.$emit("player-ready", this);
        }
      );
    },
    async destroy() {
      if (this.player) {
        this.player.dispose();
        if (this.logged()) {
          if (!this.isOver) {
            const second =
              (new Date().valueOf() - this.startTime.valueOf()) / 1000;
            await addWatchTimes(this.videoId, Math.floor(second));
          }
        }
      }
    },
    async reInit() {
      await this.destroy();
      this.init();
    }
  }
};
</script>

<style lang="scss">
.video-js-wrapper {
  width: 100%;
  height: 100%;
  .video-js {
    width: 100%;
    height: 100%;
    .vjs-big-play-button {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .vjs-control-bar {
      background-color: transparent;
    }
    .vjs-big-play-button {
      font-size: 3em;
      line-height: 2em;
      height: 2em;
      width: 2em;
      border-radius: 50%;
    }
  }
}
</style>
